'use client';
import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const CardContainer = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  align-items: center;
  margin: 0 auto;
  gap: ${({ theme, $cardGap }) => theme.spacing($cardGap)};
  grid-template-columns: ${({ $cardsPerRow }) =>
    $cardsPerRow > 1 ? `repeat(2, auto)` : '1fr'};

  @media ${({ theme }) => theme.laptopL} {
    grid-template-columns: ${({ $cardsPerRow }) =>
      $cardsPerRow > 1 ? `repeat(${$cardsPerRow}, auto)` : '1fr'};
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  margin-top: ${({ $cardsPerRow, $hasImage }) =>
    $cardsPerRow > 1 && !$hasImage ? '10px' : '0'};
`;

export const PillContainer = styled.div`
  display: flex;
  position: absolute;
  top: ${({ $cardsPerRow, $hasImage }) =>
    $cardsPerRow > 1 && !$hasImage ? '-10px' : '0'};
  right: 0;
  transform: translate(0%, -15%);
  z-index: 1;
`;
